import { render, staticRenderFns } from "./ModalHoteis.vue?vue&type=template&id=69796f78&"
import script from "./ModalHoteis.vue?vue&type=script&lang=js&"
export * from "./ModalHoteis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports